import { render, staticRenderFns } from "./ChatDefaultContent.vue?vue&type=template&id=b223584e&scoped=true"
import script from "./ChatDefaultContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatDefaultContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatDefaultContent.vue?vue&type=style&index=0&id=b223584e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b223584e",
  null
  
)

export default component.exports